import jwt from "jsonwebtoken";
import apis from "../../../api/apis";
import { SECRET_KEY } from "../../../config";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import { IUserRequestModel } from "../../../interfaces/user";
import { LOGIN, LOGOUT } from "../types";
import { notifyServerError } from "../../../config/toastNotification";

//action creators for authentication

export const userLogin = (
  data: string | jwt.JwtPayload
): { type: string; data: string | jwt.JwtPayload } => ({
  type: LOGIN,
  data,
});

export const loginUser =
  (data: IUserRequestModel) =>
  async (dispatch: any): Promise<boolean> => {
    try {
      const response = await apis.Users.validateLogin(data);
      //console.log(response);

      if (response.ResponseType === APIResponseType.Success) {
        const userData = {
          UserKey: response.ResponseData.User.UserKey,
          UserId: response.ResponseData.User.UserId,
          IntegrationId: response.ResponseData.User.IntegrationId,
          ApiKey: response.ResponseData.User.ApiKey,
          RequestingId: response.ResponseData.User.RequestingId,
          CompanyKey: response.ResponseData.User.UserCompanies[0].CompanyId,
          CompanyName: response.ResponseData.User.UserCompanies[0].CompanyName,
          LocationKey: response.ResponseData.User.UserLocations[0].LocationId,
          EnvironmentName: response.ResponseData.User.EnvironmentName,
          IsUrbanPiper:
            response.ResponseData.User.UserLocations[0].IsUrbanPiper,
        };

        /*         const userDataForJWT = {
          UserId: response.ResponseData.User.UserId,
          CompanyName: response.ResponseData.User.UserCompanies[0].CompanyName,
          IsUrbanPiper:
            response.ResponseData.User.UserLocations[0].IsUrbanPiper,
          EnvironmentName: response.ResponseData.User.EnvironmentName,
        }; */

        //console.log(userData);

        //const jwtToken = jwt.sign(userDataForJWT, SECRET_KEY);
        const jwtToken = jwt.sign(userData, SECRET_KEY);

        localStorage.setItem("User_AccessToken", jwtToken);
        dispatch(userLogin(userData));

        return true;
      } else if (response.ResponseType === APIResponseType.InvalidLogin) {
        return false;
      } else {
        notifyServerError();
        return false;
      }
    } catch (err) {
      notifyServerError();
      console.log(err);
      return false;
    }
  };

/*   export const loginUser =
  (data: IUserRequestModel) =>
  async (dispatch: any): Promise<APIResponseType> => {
    try {
      const response = await apis.Users.validateLogin(data);
      console.log(response);

      if (response.ResponseType === APIResponseType.Success) {
        const jwtToken = jwt.sign(
          response.ResponseData.User.UserId,
          SECRET_KEY
        );
        
        localStorage.setItem("User_AccessToken", jwtToken);
        dispatch(userLogin(jwt.verify(jwtToken, SECRET_KEY)));

        return response.ResponseType;
      } else if (response.ResponseType === APIResponseType.InvalidLogin) {
        return response.ResponseType;
      } else {
        return response.ResponseType;
      }
    } catch (err) {
      console.log(err);
      return APIResponseType.Error;
    }
  }; */

export const logoutUser = () => (dispatch: any) => {
  if (localStorage.getItem("User_AccessToken")) {
    localStorage.removeItem("User_AccessToken");
    if (localStorage.getItem("Cancel_Reasons")) {
      localStorage.removeItem("Cancel_Reasons");
    }
    dispatch({
      type: LOGOUT,
    });
  }
};
